import { CONTACT } from '../lib/contact';
import '../styles/whatsapp.css';

/**
 * A floating, always-available way to reach NyumbaSuite, per the contact/
 * footer brief — deliberately not a second full contact page. Bottom-LEFT
 * on purpose: AgentPanel already floats bottom-right on every public page
 * (mounted alongside this one, in SiteFooter), and two floating widgets in
 * the same corner would fight each other for the same thumb.
 */
export function WhatsAppButton() {
  return (
    <a
      className="wa-float"
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with NyumbaSuite on WhatsApp"
    >
      <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden>
        <path d="M12 2a10 10 0 0 0-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1 0 12 2Zm0 18a8 8 0 0 1-4-1.1l-.3-.2-2.8.8.8-2.7-.2-.3A8 8 0 1 1 12 20Zm4.4-6c-.2-.1-1.4-.7-1.6-.8s-.4-.1-.5.1-.6.8-.8 1-.3.1-.5 0a6.5 6.5 0 0 1-1.9-1.2 7.2 7.2 0 0 1-1.3-1.7c-.1-.2 0-.4.1-.5l.4-.4.2-.4v-.4l-.8-1.8c-.2-.5-.4-.4-.5-.4h-.5a.9.9 0 0 0-.7.3A2.8 2.8 0 0 0 6 8.9a4.9 4.9 0 0 0 1 2.6 11 11 0 0 0 4.3 3.8c2 .8 2 .5 2.4.5a2.5 2.5 0 0 0 1.6-1.1 2 2 0 0 0 .1-1.1c0-.1-.2-.1-.4-.2Z" />
      </svg>
    </a>
  );
}
